<template>
    <div>
        <b-alert show variant="warning" v-if="bannerDetails === null">
            Derzeit ist kein Banner vorhanden.
        </b-alert>
        <div v-else-if="Object.keys(bannerDetails).length > 0" class="d-flex flex-column mb-5 ">
            <p class=" font-weight-bold">Aktueller Banner </p>
            <div>
                <p>Name des Banners: <span class="font-weight-bold"> {{ bannerDetails?.name }}</span></p>
                <div>
                    <p v-if="bannerDetails?.bannerEnabled">
                        Banner ist <span class="font-weight-bold">aktiviert </span> und wird im Shop angezeigt.
                    </p>
                    <p v-else>
                        Banner ist <span class="font-weight-bold">deaktiviert </span>und wird in dem Shop nicht
                        angezeigt.
                    </p>
                </div>
                <p>Enddatum:
                    <span class="font-weight-bold">
                        {{ new Date(bannerDetails?.endDate).toLocaleDateString("De-de") }} </span>um <span
                        class="font-weight-bold">{{ new
                            Date(bannerDetails?.endDate).toLocaleTimeString("De-de") }} </span>Uhr
                </p>
                <p>Ausgewälter shop: <span class="font-weight-bold">{{ bannerDetails?.selectedShops }} </span></p>
                <div v-if="bannerDetails?.link?.url">
                    <p>
                        Hinterlegter Link: <span class="font-weight-bold"><a :href="bannerDetails?.link?.url">Zur
                                Zielseite</a></span>
                    </p>
                    <div>
                        <p v-if="bannerDetails?.link?.target === '_self'">
                            Der verlinkte Inhalt wird im aktuellen <span class="font-weight-bold">Tab oder Fenster
                            </span>
                            geladen.
                        </p>
                        <p v-else>
                            Der verlinkte Inhalt öffnet sich in einem neuen <span class="font-weight-bold">Browser-Tab
                                oder
                                Fenster.</span>
                        </p>
                    </div>
                </div>
                <div v-else>
                    <p>Kein <span class="font-weight-bold"> Link </span>vorhanden.</p>
                </div>
                <p>Schriftfarbe: <input type="color" id="foreground" name="foreground"
                        :value="bannerDetails?.textColor" /> HEX-Wert: <span class="font-weight-bold">{{
                            bannerDetails?.textColor }}</span></p>

                <p>Labelfarbe: <input type="color" id="foreground" name="foreground"
                        :value="bannerDetails?.labelColor" />
                    HEX-Wert: <span class="font-weight-bold">{{
                        bannerDetails?.labelColor }}</span></p>
            </div>
            <p>Banner in <span class="font-weight-bold">deutscher</span> Version:</p>
            <b-img class="img" :src="bannerDetails?.imgSrc_de" fluid :alt="bannerDetails?.name"></b-img>
            <p class="mt-3">Banner in <span class="font-weight-bold">Englischer </span>Version:</p>
            <b-img class="img" :src="bannerDetails?.imgSrc_en" fluid :alt="bannerDetails?.name"></b-img>
        </div>
        <SpinnerComponent v-else />
    </div>
</template>

<script>
import SpinnerComponent from "./SpinnerComponent.vue";
import { db } from "../plugins/firebase";
import { onValue, ref } from "firebase/database";


export default {
    name: 'ObtainCurrentBannerComponent',
    components: {
        SpinnerComponent
    },

    methods: {
    },
    mounted() {
        onValue(ref(db, "countdownBanner"), (snapshot) => {
            this.bannerDetails = snapshot.val()
        });
    },
    data() {
        return {
            bannerDetails: {},
        }
    }
}
</script>
<style scoped>
p {
    margin: 0;
    line-height: 1.6;
    margin-bottom: 1em;
}

.img {
    max-width: 846px;
    max-height: 288px;
    object-fit: fill;
}
</style>